import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { IonicPage,ModalController, NavParams,ViewController } from 'ionic-angular';
@IonicPage()
@Component({
  selector: 'page-select-category',
  templateUrl: 'select-category.html',
})
export class SelectCategoryPage {



dataList = [];
dataSet:any = {};

constructor(
  private modal: ModalController,
  public nvmPrms: NavParams,
  public viewCtrl :ViewController,
) { 
 let data = nvmPrms.get('data');
 this.dataSet = data;
console.log("data",data)
}


ngOnInit() {
  // this.newList.next(this.list);
}

onSearch(event) {
 
}


onClose(item?) {
  this.viewCtrl.dismiss(item);
}

dismiss(){
  this.viewCtrl.dismiss(false);

}
}


// WEBPACK FOOTER //
// ./src/pages/select-category/select-category.ts